import { Component, Input } from "@angular/core";
import { OrderDto } from "src/app/models/order-dto";
import { downloadBillOfMaterialsCsv } from "../../../helpers/bill-of-materials-csv";
import { WebAppCommonModule } from "@allbesmart/web-app-common";

@Component({
    selector: "oaibox-order-bill-of-materials",
    templateUrl: "./order-bill-of-materials.component.html",
    styleUrl: "./order-bill-of-materials.component.css",
    imports: [WebAppCommonModule],
})
export class OrderBillOfMaterialsComponent {
  @Input({ required: true }) order!: OrderDto;

  protected downloadBillOfMaterials(): void {
    const title = this.order.title ?? "order";
    downloadBillOfMaterialsCsv(
      this.order.bom ?? [],
      `${title}-bill-of-materials.csv`
    );
  }
}
